var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoBackArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 7.74978C20 8.16378 19.6554 8.49978 19.2307 8.49978H2.62552L8.4926 14.2198C8.79313 14.5128 8.79313 14.9878 8.4926 15.2808C8.34284 15.4268 8.14588 15.5008 7.94894 15.5008C7.75201 15.5008 7.5551 15.4278 7.40535 15.2808L0.225399 8.28079C-0.075133 7.98779 -0.075133 7.51275 0.225399 7.21975L7.40535 0.21975C7.70588 -0.07325 8.19307 -0.07325 8.4936 0.21975C8.79413 0.51275 8.79413 0.987785 8.4936 1.28079L2.62658 7.00076H19.2307C19.6554 6.99976 20 7.33578 20 7.74978Z",
    fill: "#344054"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoBackArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/goBackArrow.ecb1d67b861f0ea15955db146e123b52.svg";